<template>

  <v-layout class="inner-pages" column>
    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <scroll-data>
      <v-flex class="pt-0">
        <h2 class="page-head"><span class="page-heading">ANSI Accreditation</span></h2>

        <p>On Tuesday, September 19, 2017, the ANSI Certificate Accreditation Program Accreditation Committee (CAPAC)
          met and approved the recommendations of the assessors to award the Cogneti LLC accreditation under ANSI/ASTM E2659-09.</p>

        <p>By agreement certificates issued by Cogneti prior to that date are valid, unless otherwise noted.
        </p>

        <p>
          Cogneti is listed as a Certificate Provider in the ANSI directory of accredited food-handler certificate programs.</p>

      </v-flex>
    </scroll-data>
  </v-layout>

</template>

<script>
  import ScrollData from '../../ScrollData'
  import Header from '../../layouts/Header'
  export default {
    name: 'AnsiAccreditation',
    components: {Header, ScrollData}
  }
</script>



// WEBPACK FOOTER //
// src/components/views/guest/AnsiAccreditation.vue